import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Fetch a protected file as blob and open / download it
export async function openFile(path, download = false, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const type = (res.data.type || "").split(";")[0];
  if (download || (type !== "application/pdf" && !type.startsWith("image/"))) {
    const a = document.createElement("a");
    a.href = url;
    const header = res.headers["content-disposition"] || "";
    const encoded = header.match(/filename\*=UTF-8''([^;]+)/i);
    let serverName = "";
    try { serverName = encoded ? decodeURIComponent(encoded[1]) : ""; } catch { /* Use fallback name. */ }
    a.download = filename || serverName || "belge";
    document.body.appendChild(a);
    a.click();
    a.remove();
  } else {
    window.open(url, "_blank");
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export { API };
export default api;

export const isPdfFile = (filename) => /\.pdf$/i.test(filename || "");
